import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "../../../api/axiosConfig";
import * as idb from '../../../functions/databaseService/indexedDB';
import { getLatestTaskList } from "../Firebase/getLatestTaskListAction";
import signOut from "../../../functions/userIdentity/signOut";
import * as Sentry from "@sentry/capacitor";

// Action Types
export const BULK_EDIT_TASK_SUCCESS = "BULK_EDIT_TASK_SUCCESS";
export const BULK_EDIT_TASK_ERROR = "BULK_EDIT_TASK_ERROR";

// Thunk Action Creator
export const bulkEditTaskInFirebase = createAsyncThunk(
    "api/Task/bulkEdit",
    async (json, { dispatch }) => {
        try {
            const online = navigator.onLine;

            if (online) {
                const response = await axios.put(
                    `${import.meta.env.VITE_PUBLIC_DOMAIN}Task/bulkEditTask/${json.id}`,
                    json.detailsChanged,
                    {
                        headers: {
                            "Content-Type": "application/json",
                        },
                    }
                )

                if (response.status == 200) {
                    if (response.data === '') {
                        throw new Error("The last task has not been saved. Logging the user out");
                    } else {
                        idb.storeTaskList(response.data.tasks || response.data);
                    }
                }
                else {
                    throw new Error("Error editing task in firebase");
                }
                
                //get data from indexed DB
                //const taskListData = await idb.getTasks();

                //Dispatch Indexed DB instead of Axios result
                dispatch({
                    type: BULK_EDIT_TASK_SUCCESS,
                    payload: response.data
                });      
            }
            else {
                //get data from indexed DB
                const taskListData = await idb.getTasks();
                if (taskListData) {
                    //Dispatch Indexed DB instead of Axios result
                    dispatch({
                        type: FIREBASE_GET_LATEST_TASK_FILE_SUCCESS,
                        payload: taskListData
                    });
                }
                else {
                    console.log("No tasks found in IndexedDB");
                }
            }
        }
        catch (error) {
            Sentry.captureException(error, {
                tags: {
                    error_type: 'bulk_edit_failure',
                    operation: 'bulkEditTaskInFirebase',
                    is_online: navigator.onLine,
                },
                level: 'error',
                extra: {
                    task_id: json?.id,
                    status_code: error.response?.status,
                    has_recurrence_change: !!json?.detailsChanged?.recurrenceChange,
                }
            });
            dispatch({ type: BULK_EDIT_TASK_ERROR, payload: error });
            await signOut();
        }
        //.then(response => {
        //    dispatch({
        //        type: BULK_EDIT_TASK_SUCCESS,
        //        payload: response.data,
        //    });
        //})
        //.catch(error => {
        //    dispatch({ type: BULK_EDIT_TASK_ERROR, payload: error });
        //});
    }
);
